import { render, staticRenderFns } from "./SpinTheWheel.vue?vue&type=template&id=f8f64318&scoped=true&"
import script from "./SpinTheWheel.vue?vue&type=script&lang=js&"
export * from "./SpinTheWheel.vue?vue&type=script&lang=js&"
import style0 from "./SpinTheWheel.vue?vue&type=style&index=0&id=f8f64318&prod&scoped=true&lang=css&"
import style1 from "./SpinTheWheel.vue?vue&type=style&index=1&id=f8f64318&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f64318",
  null
  
)

export default component.exports